export enum StopWordType {
  'namefinder.blacklist' = 'namefinder.blacklist',
  'namepredictor.blacklist' = 'namepredictor.blacklist',
  'namefinder.namelist' = 'namefinder.namelist'
}
